module.exports = __webpack_public_path__ + "img/03_sub_uk.f8af9df0.svg";